// Group-name canonicalisation used by the xlsx import flow.
//
// Reality: the Snap master sheet has rows like "VINAY", "Vinay Group", "vinay".
// These are the same owner and we want them to collapse into one Account when
// imported. The canonical key is lowercase + whitespace-collapsed + trailing
// " group" suffix stripped.
//
// Intentionally NOT handled: misspellings like "aZIHAN" vs "ZIHHAN". Those
// canonicalise to different keys ("azihan" vs "zihhan") and appear as separate
// buckets in the preview UI, where the operator decides to merge them manually
// by choosing one existing Account for both. Silent fuzzy-merging is wrong for
// the client-facing data model -- the operator is the tiebreaker.
export function canonicaliseGroupName(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/ group$/, '')
    .trim();
}

// Convenience: returns true when the group column indicates "no group --
// this location sits directly under the brand" (spec §1.4).
export function isIndependentGroup(canonicalKey: string): boolean {
  return canonicalKey === 'independent' || canonicalKey === '' || canonicalKey === 'corporate';
}
